// removed by extract-text-webpack-plugin
module.exports = {"namespace":"WizardProgressTemplate__namespace___1QltO","todo":"WizardProgressTemplate__todo___3QtNV","doing":"WizardProgressTemplate__doing___3tNPH","done":"WizardProgressTemplate__done___2Gdt-"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/subschema/src/styles/WizardProgressTemplate.less
 ** module id = 691
 ** module chunks = 0
 **/